export default __webpack_public_path__ + "static/media/Case-Real-Time.b19b9c94.jpg";